/* eslint-disable react/prop-types */
import { sbEditable } from '@storyblok/storyblok-editable';
import React, { useEffect, useState } from 'react';

import DynamicComponent from 'components/dynamicComponent';
import Layout from 'components/shared/layout';
import SEO from 'components/shared/seo';
import News from 'templates/News';
import Project from 'templates/Project';
import TeamMember from 'templates/teamMember';

import useStoryblok from '../lib/storyblok';

const generateSpecificTemplate = (story) => {
  if (story.field_component === 'project') {
    return <Project data={story.content} />;
  }
  if (story.field_component === 'news') {
    return <News data={story.content} />;
  }
  return null;
};

const StoryblokEntry = ({ pageContext, location }) => {
  const data = pageContext;

  let story = data.storyblokEntry;

  story = useStoryblok(story, location);

  const templateComponent = generateSpecificTemplate(story);

  const components = story.content.blocks?.map((blok) => (
    <DynamicComponent blok={blok} key={blok._uid} />
  ));

  const initProjectComponents = story.content.content?.map((blok) => (
    <DynamicComponent
      blok={blok}
      key={blok._uid}
      className={`template-${data.storyblokEntry.field_component}`}
    />
  ));

  const [projectComponents, setProjectComponents] = useState(initProjectComponents);

  const baseTeam =
    data.storyblokEntry.field_component === 'team_member' ? (
      <TeamMember data={data.storyblokEntry.content} />
    ) : null;

  const [teamCompontent, setTeamComponent] = useState(baseTeam);

  useEffect(() => {
    if (story?.content.component === 'project' || story?.content.component === 'news') {
      if (story?.content.content !== undefined) {
        const updatedProjectComponents = story?.content?.content?.map((blok) => (
          <DynamicComponent
            blok={blok}
            key={blok._uid}
            className={`template-${story.content.component}`}
          />
        ));
        setProjectComponents(updatedProjectComponents);
      }
    }

    if (story?.content.component === 'team_member') {
      setTeamComponent(<DynamicComponent blok={story.content} key={story.content._uid} />);
    }
  }, [story]);

  return (
    <Layout {...sbEditable(story.content)}>
      <SEO title={story.content.seo_title} description={story.content.seo_description} />
      {story.content.seo_title && <h1 className="sr-only">{story.content.seo_title}</h1>}
      {data.storyblokEntry.field_component === 'project' ||
      data.storyblokEntry.field_component === 'news'
        ? projectComponents
        : components}
      {data.storyblokEntry.field_component === 'team_member' ? teamCompontent : null}
      {templateComponent}
    </Layout>
  );
};

export default StoryblokEntry;
